import InfiniteScrollProvider from '../../../utils/InfiniteScrollProvider'

interface UseCustomSelectStateFromInfiniteScrollProviderProps<V> {
  scrollProvider: InfiniteScrollProvider<V>
  searchText: string
  onSearchTextChange: (newText: string) => unknown
  searchResults?: V[]
}

/**
 * Uses an `InfiniteScrollProvider` to derive the state as well as a
 * pre-filtered, pre-sorted `searchResults` (if `undefined`, uses the
 * scrollers items). Must also provide `searchText` and `onSearchTextChange`.
 *
 * Calling component must be an `observer`.
 *
 * @param scrollProvider
 * @param searchResults
 * @param searchText
 * @param onSearchTextChange
 */
export function useCustomSelectStateFromInfiniteScrollProvider<V>({
  scrollProvider,
  searchResults,
  searchText,
  onSearchTextChange,
}: UseCustomSelectStateFromInfiniteScrollProviderProps<V>) {
  const inputValue = searchText
  const onInputValueChange = onSearchTextChange
  const isLoading = scrollProvider.more.pending
  const onLoadMore = scrollProvider.more
  const isEoS = scrollProvider.isDone
  return {
    onLoadMore,
    inputValue,
    onInputValueChange,
    isLoading,
    isEoS,
    searchResults: searchResults || scrollProvider.items,
  }
}
